import { defineStore } from "pinia";
import { ref } from "vue";
import { ProfileService } from "../infrastructure/adapters/ProfileService";
const profileService = new ProfileService();
export const useProfileStore = defineStore("profile", () => {
    const profile = ref(null);
    const isLoading = ref(false);
    let inflightRequest = null;
    async function fetchProfile() {
        if (profile.value)
            return profile.value;
        if (inflightRequest)
            return inflightRequest;
        isLoading.value = true;
        inflightRequest = (async () => {
            try {
                profile.value = await profileService.getProfile();
                return profile.value;
            }
            finally {
                isLoading.value = false;
                inflightRequest = null;
            }
        })();
        return inflightRequest;
    }
    function setProfile(updated) {
        profile.value = updated;
    }
    function clearProfile() {
        profile.value = null;
    }
    return { profile, isLoading, fetchProfile, setProfile, clearProfile };
});
